const usersDefaultState = {
  data: [],
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  removeError: false,
  removeSuccess: '',
  errorMessage: null
};

const usersReducer = (state = usersDefaultState, action) => {
  switch (action.type) {
    case 'START_GET_USERS':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_USERS_SUCCESS':
      return {
        ...state,
        data: action.users,
        loading: false,
        error: false,
        errorMessage: null,
        removeError: false,
        removeSuccess: false
      };
    case 'START_REMOVE_USERS':
      return {
        ...state,
        loading: true,
        removeError: false,
        errorMessage: null,
        removeSuccess: false,
      };
    case 'REMOVE_USERS_SUCCESS':
      return {
        ...state,
        data: state.data.filter(user => { // check original users and only include users that don't have that to delete ID
          return !action.userIds.includes(user.id); // includes is checking inside an array of numbers to see if any match
        }),
        loading: false,
        removeSuccess: true,
        removeError: false,
      };
    case 'SHOW_REMOVE_ERROR':
      return {
        ...state,
        loading: false,
        removeError: true,
        removeSuccess: false
      };
    case 'REMOVE_USERS_CLEAR':
      return {
        ...state,
        loading: false,
        removeError: false,
        removeSuccess: false
      };
    case 'SHOW_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default usersReducer;
